module.exports = __webpack_public_path__ + "static/DINPro-Light-4fb6bea54d7b4c98c1b4d46914147c65.woff";